<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import {ref, defineExpose, getCurrentInstance} from "vue";
import { useRouter } from 'vue-router'
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import jobFairUserService from "../../../services/jobFair/jobFairUserService";
import jobFairCorpService from "../../../services/jobFair/jobFairCorpService";
import MyPageCorpJobFairCorpInfoView from "../../../views/mypage/corpJobFair/MyPageCorpJobFairCorpInfoView.vue";
import jobFairGnbService from "@/pages/user/services/jobFair/jobFairGnbService";
import JobFairJobNoticeModal from "@/pages/user/components/modal/jobFair/JobFairJobNoticeModal.vue";

const router = useRouter();
const loadingStore = usePageLoadingStore()
const globals = getCurrentInstance().appContext.config.globalProperties;
const { $pageListBoardNo, alert, confirm } = globals;

const jobNoticeList = ref([]);
const currentPage = ref(1);
const pageSize = 5;
const totalPages = ref(1);
const totalCount = ref(0);

const baseModal = ref(null);
const resolvePromise = ref(null);
const jobNoticeModal = ref(null); // 채용공고 보기

const modalBody = ref(null)
const modalContent = ref([])
const okButtonText = ref("네");
const cancelButtonText = ref("아니오");

const showButtons = ref(false);
const showPropsButtons = ref(false);
const corpLikeTxts = ref("♡관심기업");
const ojfIds = ref(0);
const corpIds = ref(0);
const jobNoticeSeqs = ref(0);
const commonDatas = ref('N'); // 구직자: 면접제안 여부 / 기업: 사용자의 회사아이디
const masterYns = ref('N'); // 마스터 여부

// 기업 정보
const ojfCorporationDetail = (corpId) => {
  loadingStore.loading = true;
  jobFairCorpService.ojfCorporationDetail(corpId)
    .then( (res) => {
      loadingStore.loading = false;
      if(res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;
        // console.log(result);
        modalBody.value.setCorpInfo(result);
      }
    }).catch( (error) =>  {
      loadingStore.loading = false;
    });
}

// 기업정보 보기 팝업의 채용공고 리스트
const ojfGnbCorpInfoJobNoticeList = (corpId, ojfId) => {
  corpIds.value = corpId;
  ojfIds.value = ojfId;

  loadingStore.loading = true;
  let paramObj = {
    ojfId: ojfId,
    corpId: corpId,
    pageNumber: currentPage.value,
    size: pageSize,
  }
  jobFairGnbService.ojfGnbCorpInfoJobNoticeList(paramObj)
    .then( (res) => {
      loadingStore.loading = false;
      if(res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;
        // console.log(result);
        totalPages.value = result.totalPages;
        totalCount.value = result.totalElements;
        jobNoticeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize, currentPage.value);
      }
    }).catch( (error) =>  {
      loadingStore.loading = false;
    });
}

// 기업정보 수정
const onClickCorpUpdate = (ojfId) => {
  router.push({name: 'MyPageCorpInfoUpdate' })
}

// 관심 기업 관심여부
const onClickCorpYn = async (ojfId, corpId, inteYn) => {
  if (inteYn === 'N') {
    modalContent.value = ["관심기업을 등록하시겠습니까?"];
    okButtonText.value = "관심기업 등록";
    inteYn = "Y"
  } else {
    modalContent.value = ["관심기업을 삭제하시겠습니까?"];
    okButtonText.value = "관심기업 삭제";
    inteYn = "N"
  }

  const ok = await confirm(modalContent.value, okButtonText.value, cancelButtonText.value);
  if (ok) {
    let paramObj = {
      ojfId: ojfId,
      corpId: corpId,
      interestYn: inteYn,
    }

    jobFairUserService.ojfInterestCorpEntryYn(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          //const result = res.data.result;
          if (inteYn === 'Y') {
            alert("등록하였습니다.");
            corpLikeTxts.value = "♥관심기업";
            commonDatas.value = "Y";
          } else {
            alert("삭제하였습니다.");
            corpLikeTxts.value = "♡관심기업";
            commonDatas.value = "N";
          }
        } else {
          alert("실패하였습니다.");
          console.log(res);
        }
      }).catch( (res) =>  {
        loadingStore.loading = false;
        alert("실패하였습니다.");
      });
  }
}

// 채용공고 보기
const onClickJobNotice = async (jobNoticeSeq, corpId, ojfId) => {
  let paramObj = {
    jobNoticeSeq: jobNoticeSeq,
  }

  jobFairUserService.ojfInterestJobNoticeYn(paramObj)
    .then( async (res) => {
      loadingStore.loading = false;
      if(res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;
        jobNoticeModal.value.init(false, true, false, ojfId, 0, result);
        jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
        jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId, corpId);
        jobNoticeModal.value.ojfCorporationDetail(corpId);
        await jobNoticeModal.value.show();

        baseModal.value.close();
        resolvePromise.value(false);
      } else {
        console.log(res);
      }
    }).catch( (res) =>  {
      loadingStore.loading = false;
      console.log(res);
    });
}

const onSelectedPage = (pageNo) => {
  currentPage.value = pageNo;
  ojfGnbCorpInfoJobNoticeList(corpIds.value, ojfIds.value);
}

const show = () => {
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const _confirm = async () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

// commonData = inteYn - 구직자: 관심기업 유무
// commonData = userCorpId - 기업: 사용자의 회사아이디
const init = (showButton, showPropsButton, ojfId, commonData, masterYn) => {
  // 기본값 저장
  showButtons.value = showButton; // 수정 버튼 (참가확정 기업 마스터만)
  showPropsButtons.value = showPropsButton; // 관심기업 버튼

  // 면접제안 데이터
  ojfIds.value = ojfId;

  // 관심기업 여부
  if (commonData === 'Y') {
    commonData = 'Y';
    corpLikeTxts.value = "♥관심기업"
  } else if (commonData === 'N') {
    commonData = 'N';
    corpLikeTxts.value = "♡관심기업"
  }
  commonDatas.value = commonData;

  // 회원 마스터 유무
  masterYns.value = masterYn;
}

defineExpose({
  show,
  init,
  ojfCorporationDetail,
  ojfGnbCorpInfoJobNoticeList,
})
</script>

<template>
  <Modal ref="baseModal" class="vld-parent">
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body">
        <MyPageCorpJobFairCorpInfoView ref="modalBody"/>
        <!-- s : 채용 공고 목록 -->
        <div class="mt-sm gray-bg">
          <div class="resume-wrap">
            <section>
              <h2 class="mb-sm">채용 공고</h2>
              <div class="table-form">
                <table class="table-form vertical" v-if="jobNoticeList !== null">
                  <tr>
                    <th>채용상태</th>
                    <th>채용 공고 제목</th>
                    <th>관심 카테고리</th>
                    <th>직무</th>
                  </tr>
                  <tr v-for="list in jobNoticeList">
                    <td>{{ list.jobStatus }}</td>
                    <td class="link blue" @click="onClickJobNotice(list.jobNoticeSeq, list.corpId, ojfIds)">{{ list.jobName }}</td>
                    <td>{{ list.interests }}</td>
                    <td>{{ list.desiredJob }}</td>
                  </tr>
                </table>
              </div>
            </section>
          </div>
          <Paginate
              v-if="jobNoticeList.length > 0"
              v-model="currentPage"
              :page-count="totalPages"
              :click-handler="onSelectedPage"
          />
        </div>
        <!-- e : 채용 공고 목록 -->
      </div>
      <div v-if="showButtons && commonDatas === corpIds && masterYns === 'Y'" class="modal-footer btn-wrap">
        <KSAPrimaryButton text="수정" @click="onClickCorpUpdate(ojfIds)" style="margin-left: auto" />
      </div>
      <div v-if="showPropsButtons" class="modal-footer btn-wrap">
        <!-- 관심기업 -->
        <KSASecondaryButton :text="corpLikeTxts" @click="onClickCorpYn(ojfIds, corpIds, commonDatas)" class="red_button"/>
      </div>
    </div>
  </Modal>
  <JobFairJobNoticeModal ref="jobNoticeModal"/> <!-- 채용공고 보기 -->

</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
  }
  .file, .link {
    color: $blue_color;
    cursor: pointer;
  }
  .link {
    color: $blue_color;
    text-decoration: underline;
  }
  .gray-bg {
    background: $gray-thin_color;
    padding: 30px;
  }
  .modal-footer {
    padding: 0 30px;
  }
}
</style>